"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testStepsNavigation = exports.storySchema = exports.steps = exports.storyMetadataSchema = exports.dialogStepSchema = exports.stepGestureSchema = exports.stepCharacterPositionSchema = exports.stepCharacterMotionSchema = exports.stepCharacterMotionPositionSchema = exports.characterOffsetSchema = exports.stepCameraSchema = exports.cameraMotionSchema = exports.choiceTypesSchema = exports.choiceTypeSchema = exports.stepBubbleSchema = exports.stepBubbleLayoutSchema = exports.navigationSchema = exports.parallaxtSchema = exports.parallaxLayertSchema = exports.characters = exports.characterSchema = exports.branchCharacterLayoutSchema = exports.charactersMetadata = exports.characterMetadataSchema = exports.characterId = void 0;
const yup_1 = require("yup");
const base_1 = require("../base");
const consts_1 = require("../consts");
exports.characterId = (0, base_1.OneOf)(consts_1.characterIds);
const characterColors = (0, base_1.OneOf)(consts_1.labelColors);
const validCDNUrl = (0, yup_1.string)().test('isValidCDNUrl', (v) => Boolean(v && v.startsWith('https://cms.characters')));
const validAssemblerNUrl = (0, yup_1.string)().test('validAssemblerNUrl', (v) => Boolean(v && v.startsWith('https://sverse-character-storage') && v.includes('assembler')));
const validAnimationUrl = (0, yup_1.string)().test('validAnimationUrl', (v) => validCDNUrl.isValidSync(v) || validAssemblerNUrl.isValidSync(v));
const characterAnimationsTest = {
    name: 'characterAnimationsTest',
    message: "characterAnimationsTest has failed validation",
    test: (value) => {
        if (!value) {
            return false;
        }
        const testKeys = Object.keys(value).every(k => (0, yup_1.string)().isValidSync(k) && k.startsWith('a_') && k.endsWith('.json'));
        const testValues = Object.values(value).every(v => (0, yup_1.string)().isValidSync(v) && validAnimationUrl.isValidSync(v));
        const isValid = testValues && testKeys;
        if (!isValid) {
            console.error('Error: characterAnimationsTest', {
                testKeys,
                testValues
            });
        }
        return isValid;
    }
};
const characterAnimations = (0, yup_1.mixed)().test(characterAnimationsTest);
exports.characterMetadataSchema = (0, yup_1.object)({
    id: (0, yup_1.string)().required(),
    name: (0, yup_1.string)().required(),
    color: characterColors.required(),
    skeleton: (0, yup_1.string)().required(),
    skin: (0, yup_1.string)().required(),
    animations: characterAnimations.required(),
    tokenId: (0, yup_1.string)().required(),
    contractAddress: (0, yup_1.string)().required(),
    attributes: (0, yup_1.string)().default(undefined),
    version: (0, yup_1.string)().default(undefined),
}).noUnknown();
const charactersMetadataTest = {
    name: 'charactersMetadataTest',
    exclusive: false,
    message: "charactersMetadataTest has failed validation",
    test: function (value) {
        var _a;
        if (!value) {
            return false;
        }
        const keys = Object.keys(value);
        if (keys.length !== 3) {
            return false;
        }
        const testKeys = keys.every(k => (0, yup_1.string)().isValidSync(k) && exports.characterId.isValidSync(k));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const story = this.parent;
        // We need this because testing migration before going to `getDialog` it doesnt replace the metadata url for the schema expect
        const isValidatingMigrator = ((_a = story === null || story === void 0 ? void 0 : story.metadata) === null || _a === void 0 ? void 0 : _a.editedBy) === 'migrator';
        const values = Object.values(value);
        const testValues = values.every(v => {
            if (!isValidatingMigrator && typeof v === 'string') {
                return false;
            }
            if (isValidatingMigrator && typeof v === 'string') {
                return (0, yup_1.string)().isValidSync(v);
            }
            return exports.characterMetadataSchema.isValidSync(v);
        });
        const isValid = testValues && testKeys;
        if (!isValid) {
            console.error('Error: charactersMetadataTest', {
                testKeys,
                testValues
            });
        }
        return isValid;
    }
};
exports.charactersMetadata = (0, yup_1.mixed)().test(charactersMetadataTest);
exports.branchCharacterLayoutSchema = (0, yup_1.object)({
    x: (0, yup_1.number)().required(),
    y: (0, yup_1.number)().required(),
    scale: (0, yup_1.number)().required(),
    zIndex: base_1.int.required(),
    dir: (0, yup_1.number)().oneOf(consts_1.directions).required(),
    layer: base_1.int.required(),
}).noUnknown();
exports.characterSchema = (0, yup_1.object)({
    id: exports.characterId.required(),
    layout: exports.branchCharacterLayoutSchema.required(),
    disabledOnStart: (0, yup_1.boolean)().default(undefined),
    displayName: (0, yup_1.string)().default(undefined),
}).noUnknown();
const charactersTest = {
    name: 'charactersTest',
    exclusive: false,
    message: "charactersTest has failed validation",
    test: function (value) {
        if (!value) {
            return false;
        }
        const keys = Object.keys(value);
        if (keys.length !== 3) {
            return false;
        }
        const testKeys = JSON.stringify(keys.sort()) === JSON.stringify(consts_1.characterIds.sort());
        const values = Object.values(value);
        const testValues = values.every(v => {
            return exports.characterSchema.isValidSync(v);
        });
        const isValid = testValues && testKeys;
        if (!isValid) {
            console.error('Error: charactersTest', {
                testKeys,
                testValues
            });
        }
        return isValid;
    }
};
exports.characters = (0, yup_1.mixed)().test(charactersTest);
exports.parallaxLayertSchema = (0, yup_1.object)({
    image: (0, yup_1.string)().required(),
    width: (0, yup_1.number)().default(undefined),
    height: (0, yup_1.number)().default(undefined),
    x: (0, yup_1.number)().default(undefined),
    y: (0, yup_1.number)().default(undefined),
}).noUnknown();
exports.parallaxtSchema = (0, yup_1.object)({
    width: (0, yup_1.number)().required(),
    height: (0, yup_1.number)().required(),
    y: (0, yup_1.number)().required(),
    layers: (0, yup_1.array)().of(exports.parallaxLayertSchema).required(),
}).noUnknown();
exports.navigationSchema = (0, yup_1.object)({
    id: (0, yup_1.string)().required(),
    parent: (0, yup_1.string)().default(undefined),
    previous: (0, yup_1.string)().default(undefined),
    next: (0, yup_1.string)().default(undefined),
}).noUnknown();
const direction = (0, base_1.OneOf)(consts_1.directions);
exports.stepBubbleLayoutSchema = (0, yup_1.object)({
    x: (0, yup_1.number)().required(),
    y: (0, yup_1.number)().required(),
    dirX: direction.required(),
    dirY: direction.required(),
    tailOffset: (0, yup_1.number)().default(undefined),
}).noUnknown();
exports.stepBubbleSchema = (0, yup_1.object)({
    mode: (0, base_1.OneOf)(consts_1.bubbleModes).default(undefined),
    tagname: (0, yup_1.string)().default(undefined),
    tagcolor: characterColors.default(undefined),
    charID: exports.characterId.default(undefined),
    layout: exports.stepBubbleLayoutSchema.required(),
    caption: (0, yup_1.string)().required()
}).noUnknown();
const choiceTypeId = (0, base_1.OneOf)(consts_1.choiceIds);
const choiceTypeType = (0, base_1.OneOf)(consts_1.choiceTypes);
exports.choiceTypeSchema = (0, yup_1.object)({
    id: choiceTypeId.required(),
    type: choiceTypeType.default(undefined),
    caption: (0, yup_1.string)().required(),
    navigation: exports.navigationSchema.required(),
}).noUnknown();
exports.choiceTypesSchema = (0, yup_1.object)({
    a: exports.choiceTypeSchema,
    b: exports.choiceTypeSchema.default(undefined),
    c: exports.choiceTypeSchema.default(undefined),
}).noUnknown();
const stepCameraPreset = (0, base_1.OneOf)(consts_1.cameraPresets);
exports.cameraMotionSchema = (0, yup_1.object)({
    ease: (0, base_1.OneOf)(consts_1.cameraEases).default(undefined),
    duration: (0, yup_1.number)().default(undefined),
    zoom: (0, yup_1.number)().default(undefined),
    easeParams: (0, yup_1.mixed)().default(undefined),
    // not be used in current specs but could easily be added:
    // x: number().optional(),
    // y: number().optional(),
    // not sure we want to enable this one, it may break a few things:
    // rotation: number().optional(),
});
exports.stepCameraSchema = (0, yup_1.object)({
    charID: exports.characterId.default(undefined),
    preset: stepCameraPreset,
    motions: (0, yup_1.object)({
        // camera motion to the specified preset
        toPreset: exports.cameraMotionSchema.default(undefined),
        // camera motion that starts with the character speech
        alongSpeech: exports.cameraMotionSchema.default(undefined),
        // example of other possible motions:
        // camera motion that loops throughout the character speech
        // throughoutSpeech: cameraMotionSchema.optional(),
        // camera motion that starts when the character speech has ended
        // postSpeech: cameraMotionSchema.optional(),
    }).default(undefined),
}).noUnknown();
exports.characterOffsetSchema = (0, yup_1.object)({
    x: (0, yup_1.number)().default(undefined),
    y: (0, yup_1.number)().default(undefined),
    zIndex: (0, yup_1.number)().default(undefined),
}).noUnknown();
const coordinateSchema = (0, yup_1.object)({
    x: (0, yup_1.number)().default(undefined),
    y: (0, yup_1.number)().default(undefined),
}).noUnknown();
exports.stepCharacterMotionPositionSchema = (0, yup_1.object)({
    x: (0, yup_1.number)().required(),
    y: (0, yup_1.number)().required(),
}).noUnknown();
exports.stepCharacterMotionSchema = (0, yup_1.object)({
    to: exports.stepCharacterMotionPositionSchema.default(undefined),
    speed: (0, yup_1.number)().required(),
    type: (0, base_1.OneOf)(consts_1.characterMotionTypes).default(undefined),
}).noUnknown();
exports.stepCharacterPositionSchema = coordinateSchema;
exports.stepGestureSchema = (0, yup_1.object)({
    charID: exports.characterId.required(),
    dirX: direction.default(undefined),
    gesture: (0, yup_1.string)().default(undefined),
    loop: (0, yup_1.boolean)().default(undefined),
    backToIdle: (0, yup_1.boolean)().default(undefined),
    delay: (0, yup_1.number)().default(undefined),
    charPos: exports.stepCharacterPositionSchema.default(undefined),
    charOffset: exports.characterOffsetSchema.default(undefined),
    charMotion: exports.stepCharacterMotionSchema.default(undefined),
}).noUnknown();
exports.dialogStepSchema = (0, yup_1.object)({
    navigation: exports.navigationSchema.required(),
    gestures: (0, yup_1.array)().of(exports.stepGestureSchema).required(),
    parallax: exports.parallaxtSchema.default(undefined),
    camera: exports.stepCameraSchema.default(undefined),
    bubble: exports.stepBubbleSchema.default(undefined),
    choices: exports.choiceTypesSchema.default(undefined),
}).noUnknown();
exports.storyMetadataSchema = (0, yup_1.object)({
    timestamp: base_1.uint.required(),
    version: base_1.uint.required(),
    saveCount: base_1.int.required(),
    editedBy: (0, base_1.OneOf)(consts_1.editedBy).required(),
    templateIndex: (0, yup_1.string)().default(undefined),
}).noUnknown();
exports.steps = (0, yup_1.array)().of(exports.dialogStepSchema);
exports.storySchema = (0, yup_1.object)({
    filterPreset: (0, base_1.OneOf)(consts_1.filterPresets).required(),
    charactersMetadata: exports.charactersMetadata.required(),
    initialStep: (0, yup_1.string)().required(),
    parallax: exports.parallaxtSchema.required(),
    characters: exports.characters.required(),
    steps: exports.steps.required(),
    // Metadata
    /** @deprecated Use 'timestamp' from metadata instead */
    timestamp: base_1.uint.required(),
    /** @deprecated Use 'lastVersion' from metadata instead */
    lastVersion: (0, yup_1.string)().test((value) => value === undefined),
    /** @deprecated Use 'version' from metadata instead */
    version: (0, yup_1.string)().required(),
    /** @deprecated Use 'saveCount' from metadata instead */
    saveCount: base_1.uint,
    /** @deprecated Use 'editedBy' from metadata instead */
    editedBy: (0, base_1.OneOf)(consts_1.editedBy).default(undefined),
    metadata: exports.storyMetadataSchema.default(undefined),
}).noUnknown();
const linkSteps = (steps, initialId) => {
    const initialStep = steps.find((step) => step.navigation.id === initialId);
    if (!initialStep) {
        throw Error(`Error: Cannot find 'initialStep' in 'linkSteps()'`);
    }
    // Start iterating from the second step since first step doesn't have 'previous'
    let nextStep = steps.find((step) => step.navigation.id === initialStep.navigation.next);
    let previousStep = initialStep;
    while (nextStep) {
        // set the step previous as the id of the previous step
        nextStep.navigation.previous = previousStep.navigation.id;
        // move cursor to next step until we cant find any more next
        previousStep = nextStep;
        nextStep = steps.find((step) => step.navigation.id === nextStep.navigation.next);
    }
    return steps;
};
const testStepsNavigation = (initialStep) => {
    return exports.steps.test({
        name: 'testNavigationLink',
        exclusive: false,
        message: "testNavigationLink has failed validation",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        test: function (value) {
            const steps = value;
            let storylineIds = [undefined];
            const choiceStep = steps.find(step => step.choices);
            if (choiceStep) {
                const parentIds = Object.values(choiceStep.choices).map((v) => v === null || v === void 0 ? void 0 : v.navigation.parent);
                storylineIds = storylineIds.concat(parentIds);
            }
            const linkedSteps = [];
            storylineIds.forEach((storyline) => {
                const storylineSteps = steps.filter((step) => step.navigation.parent === storyline);
                const initialId = storyline ? storyline.split('/')[1] : initialStep;
                linkedSteps.push(...linkSteps(storylineSteps, initialId));
            });
            const isValid = linkedSteps.length === steps.length;
            if (!isValid) {
                console.error(`Failed to validate steps navigation`, {
                    initialStep,
                    storylineIds,
                    steps,
                    linkedSteps,
                });
            }
            return isValid;
        }
    });
};
exports.testStepsNavigation = testStepsNavigation;
//# sourceMappingURL=story.js.map